import React, { useState } from 'react';
import Modal from 'react-modal';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config';
import './ModalShare.css';

Modal.setAppElement('#root');

function ModalShare({ isOpen, onClose, url, collectionUuid, readonly, readonlyEnabled }) {
    const [readonlyEnabledState, setReadonlyEnabledState] = useState(readonlyEnabled);

    const copy = (id) => {
        const copyText = document.getElementById(id);
        copyText.select();
        copyText.setSelectionRange(0, 99999);
        document.execCommand("copy");
        toast.success("Link copied", {
            position: 'top-center',
            autoClose: 3000
        });
    };

    const enableReadonly = () => {
        const path = config.serverPath + '/api/getrobookmarksid';
        const params = {
            collection_uuid: collectionUuid
        };

        axios.get(path, { params })
            .then((res) => {
                if (res.data.status === 'fail') {
                    console.error(res.data.message, params);
                    return;
                }
                setReadonlyEnabledState(true);
            })
            .catch((error) => {
                console.error(error, params);
            });
    };

    const getReadonlyUrl = () => {
        if (readonlyEnabledState) {
            return window.location.href.replace('/bookmarks/', '/robookmarks/');
        }
        return "Not enabled";
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            className="relative max-w-md w-full mx-auto mt-20 bg-white rounded-2xl shadow-2xl p-8 outline-none"
            overlayClassName="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-start justify-center z-50 p-4"
        >
            <div className="container">
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 transition-colors"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div className="formGroup">
                    <div className="text-2xl font-bold text-gray-900 mb-6">Share this collection</div>
                    <div className="formLabel">
                        Readonly URL
                        {readonlyEnabledState ? (
                            <Button
                                variant="dark"
                                className="btnCopy"
                                onClick={() => copy('roUrlShare')}
                            >
                                Copy
                            </Button>
                        ) : (
                            <Button
                                variant="dark"
                                className="btnCopy"
                                onClick={enableReadonly}
                            >
                                Enable readonly
                            </Button>
                        )}
                    </div>
                    <input
                        className="formField"
                        type="text"
                        value={getReadonlyUrl()}
                        id="roUrlShare"
                        readOnly
                    />
                    {!readonly && (
                        <div>
                            <div className="formLabel">
                                Editable URL
                                <Button
                                    variant="dark"
                                    className="btnCopy"
                                    onClick={() => copy('urlShare')}
                                >
                                    Copy
                                </Button>
                            </div>
                            <input
                                className="formField"
                                type="text"
                                value={url}
                                id="urlShare"
                                readOnly
                            />
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
}

export default ModalShare;
